import { Task } from '@admiin-com/ds-graphql';
import {
  WBLinkButton,
  WBList,
  WBListItem,
  WBTypography,
} from '@admiin-com/ds-web';
import { WBFlex } from '@admiin-com/ds-web';
import { getFileNameFromKey } from '@admiin-com/ds-amplify-web';
import LoadSvgIcon from '../../../../component/LoadSvgIcon/LoadSvgIcon';
import { useDownloadSupportDoc } from '../../../hooks/useDownloadSupportDoc/useDownloadSupportDoc';
import FileIcon from '../../../../../assets/icons/file-white.svg';
import { t } from 'i18next';
export const SupportDoc = ({ task }: { task: Task }) => {
  const downloadSupportDocument = useDownloadSupportDoc();
  if (!task.supportDocuments?.length) {
    return null;
  }
  return (
    <WBFlex flexDirection={'column'} gap={1}>
      <WBTypography variant="body2" fontWeight={'700'}>
        {t('supportDocuments', { ns: 'tasks' })}
      </WBTypography>
      <WBList>
        {task.supportDocuments.map(
          (supportDocument) =>
            supportDocument && (
              <WBListItem key={supportDocument.key}>
                <WBLinkButton
                  key={supportDocument.key}
                  sx={{
                    color: 'primary.main',
                    textDecoration: 'underline',
                    fontSize: 'body1.fontSize',
                  }}
                  onClick={() => {
                    downloadSupportDocument(supportDocument.key, task);
                  }}
                >
                  <WBFlex alignItems={'center'} gap={0.5}>
                    <LoadSvgIcon component={FileIcon} width={20} height={20} />
                    {supportDocument?.name ||
                      getFileNameFromKey(supportDocument?.key) ||
                      'Document.pdf'}
                  </WBFlex>
                </WBLinkButton>
              </WBListItem>
            )
        )}
      </WBList>
    </WBFlex>
  );
};
